const abilityGroups = {
    FOUNDATIONAL_SKILLS: {
        icon: <i class="fa-light fa-cubes" />,
        label: "אבני יסוד",
        key: "FOUNDATIONAL_SKILLS"
    },
    FLUENCY: {
        icon: <i class="fa-solid fa-wave-square" />,
        label: "שטף קריאה",
        key: "FLUENCY"
    }
}

export default abilityGroups